<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-input prefix-icon="el-icon-search" clearable v-model="searchText" style="width: 260px"></el-input>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
      <el-upload
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :show-file-list="false"
        :action="$baseUrl + 'api/uploadPartsCoeList'"
        :on-success="uploadExcelSuccess"
        :on-error="uploadExcelFailed"
        :before-upload="beforeExcelUpload"
        style="display: inline; margin-left: 10px">
        <el-button>上传</el-button>
      </el-upload>
      <el-button @click="exportData" style="margin-left: 10px">
        <a :href="exportUrl">下载模版</a>
      </el-button>
    </div>
    <el-table :data="partsCoeList" class="table-border" v-loading="loading"
              header-cell-class-name="table-head">
      <el-table-column type="index" label="序号" fixed></el-table-column>
      <el-table-column label="部位名称" min-width="120" fixed>
        <template #default="{row}">
          <div v-loading="$isLoading('Parts')">{{ row.partsId | valueName('Parts') }}</div>
        </template>
      </el-table-column>
      <el-table-column label="钣金 【系数/价格(元)】" align="center">
        <el-table-column v-for="(damage, index) in sheetMetalDamageDegreeMap" :key="index + 0" align="center"
                         width="80">
          <template #header>
            <div>{{damage}}</div>
          </template>
          <template #default="{row}">
            <div>{{ row.sheetMetalCoe[index][0] }} / {{row.sheetMetalCoe[index][1]}}</div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="喷漆 【系数/价格(元)】" align="center">
        <el-table-column v-for="(damage, index) in paintDamageDegreeMap" :key="index + 1" align="center" width="80">
          <template #header>
            <div>{{damage}}</div>
          </template>
          <template #default="{row}">
            <div>{{ row.paintCoe[index][0] }} / {{row.paintCoe[index][1]}}</div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column align="center" width="80">
        <template #header>
          <div>快修</div>
        </template>
        <template #default="{row}">
          <div>{{ row.quickCoe[0] }} / {{row.quickCoe[1]}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" width="80">
        <template #header>
          <div>拆检</div>
        </template>
        <template #default="{row}">
          <div>{{ row.disassemblyCoe[0] }} / {{row.disassemblyCoe[1]}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" width="80">
        <template #header>
          <div>辅助装配</div>
        </template>
        <template #default="{row}">
          <div>{{ row.assemblyCoe[0] }} / {{row.assemblyCoe[1]}}</div>
        </template>
      </el-table-column>

      <el-table-column :width="deletable ? 70 : 80" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && !deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" @click="edit(row)" size="mini">{{readOnly ? '查看' : '编辑'}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :width="deletable ? 80: 1" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" size="mini" @click="deletePartsCoe(row)" class="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="text-align: center; margin-top: 10px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 50]"
        :page-size="page.size"
        layout="sizes, total, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>

    <edit-partsCoe-dialog :visible.sync="dialog.show" :partsCoe="dialog.partsCoe"
                          :read-only="readOnly"
                          :parts-id-set="partsIdSet"></edit-partsCoe-dialog>
  </div>
</template>

<script>
  import EditPartsCoeDialog from '@/views/car/parts-coe/EditPartsCoeDialog'
  import { PartsCoe } from '@/store/objdef/objectDef'
  import authority from '@/utils/authority'
  import { shareDataMixin } from '@/views/mixins/ShareData'

  export default {
    name: 'PartsCoeList',
    mixins: [shareDataMixin],
    components: { EditPartsCoeDialog },
    data () {
      return {
        loading: false,
        searchText: null,
        dialog: {
          show: false,
          partsCoe: new PartsCoe()
        },
        page: {
          size: 10,
          current: 1
        }
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true
        this.$store.dispatch('partsCoe/all').finally(() => {
          this.loading = false
        })
      },
      add () {
        this.dialog.partsCoe = new PartsCoe()
        this.dialog.show = true
      },
      edit (partsCoe) {
        this.dialog.partsCoe = this.$_.cloneDeep(partsCoe)
        this.dialog.show = true
      },
      deletePartsCoe (partsCoe) {
        const partsName = this.$nameMap.Parts[partsCoe.partsId]
        this.$confirm(`确认删除【${partsName}】的系数, 是否继续?`, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('partsCoe/delete', partsCoe).then(() => {
            this.$message.success('删除成功!')
          })
        }).catch(() => {
        })
      },
      exportData () {
        window.location.href = this.exportUrl
      },
      uploadExcelSuccess (res, file) {
        this.loadData()
        this.$message.success('上传成功!')
      },
      uploadExcelFailed (err) {
        this.$message.warning('上传失败!' + err)
      },
      beforeExcelUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 10MB!')
        }
        return isLt2M
      },
      handleSizeChange (val) {
        this.page.size = val
      },
      handleCurrentChange (val) {
        this.page.current = val
      }
    },
    computed: {
      exportUrl () {
        return this.$baseUrl + 'api/downloadPartsCoeTemplate'
      },
      activePartsCoeList () {
        const list = this.$store.state.partsCoe.partsCoeList
        if (!this.searchText) return list

        return list.filter(partsCoe => this.$nameMap.Parts[partsCoe.partsId].indexOf(this.searchText) !== -1)
      },
      partsCoeList () {
        const begIndex = this.page.size * (this.page.current - 1)
        return this.activePartsCoeList.slice(begIndex, begIndex + this.page.size)
      },
      totalCount () {
        return this.activePartsCoeList.length
      },
      readOnly () {
        return !this.$hasPermission(authority.EDIT_COE)
      },
      addable () {
        return this.$hasPermission(authority.ADD_COE)
      },
      deletable () {
        return this.$hasPermission(authority.DELETE_COE)
      },
      partsIdSet () {
        return new Set((this.$store.state.partsCoe.partsCoeList || []).map(partsCoe => partsCoe.partsId))
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ th {
    height: 40px;
  }
</style>
